module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-tab"
  }, [_c('wb-datatable', _vm._b({
    attrs: {
      "searchKey": 'email'
    },
    on: {
      "addEmit": _vm.openCreateDialog,
      "editEmit": _vm.openUpdateDialog,
      "deleteEmit": _vm.openConfirmDialog
    }
  }, 'wb-datatable', _vm.tableProps, false)), _vm._v(" "), _c('md-dialog', {
    ref: "createDialog"
  }, [_c('md-dialog-title', [_vm._v("Create user")]), _vm._v(" "), _c('md-dialog-content', [_c('form', [_c('md-input-container', [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.newUser.user.name),
      callback: function($$v) {
        _vm.$set(_vm.newUser.user, "name", $$v)
      },
      expression: "newUser.user.name"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.newUser.user.email),
      callback: function($$v) {
        _vm.$set(_vm.newUser.user, "email", $$v)
      },
      expression: "newUser.user.email"
    }
  }), _vm._v(" "), (_vm.errorMessage) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()], 1), _vm._v(" "), (_vm.isQuinyx) ? _c('md-input-container', [_c('label', [_vm._v("User ID")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.newUser.user.id),
      callback: function($$v) {
        _vm.$set(_vm.newUser.user, "id", $$v)
      },
      expression: "newUser.user.id"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "selectedApp"
    }
  }, [_vm._v("Select an application")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "id": "userEmail",
      "options": _vm.appsCopy,
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": false,
      "placeholder": "Application Name",
      "label": "Name"
    },
    on: {
      "input": function($event) {
        return _vm.selectRoleByAppId(_vm.selectedApp)
      }
    },
    model: {
      value: (_vm.selectedApp),
      callback: function($$v) {
        _vm.selectedApp = $$v
      },
      expression: "selectedApp"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "role"
    }
  }, [_vm._v("Set a role")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "disabled": !_vm.newUser.appId,
      "name": "role",
      "id": "role"
    },
    model: {
      value: (_vm.newUser.role),
      callback: function($$v) {
        _vm.$set(_vm.newUser, "role", $$v)
      },
      expression: "newUser.role"
    }
  }, _vm._l((_vm.roles), function(role, index) {
    return (_vm.roles) ? _c('md-option', {
      key: index,
      attrs: {
        "value": role
      }
    }, [_vm._v(_vm._s(role))]) : _vm._e()
  }), 1)], 1)], 1)]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeCreateDialog(false)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeCreateDialog(true)
      }
    }
  }, [_vm._v("Create")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "updateDialog"
  }, [_c('md-dialog-title', [_vm._v("Update User")]), _vm._v(" "), _c('md-dialog-content', [(_vm.user) ? _c('form', [_c('md-input-container', [_c('label', [_vm._v("User name")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.user.username),
      callback: function($$v) {
        _vm.$set(_vm.user, "username", $$v)
      },
      expression: "user.username"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Team ID")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.user.teamId),
      callback: function($$v) {
        _vm.$set(_vm.user, "teamId", $$v)
      },
      expression: "user.teamId"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('md-dialog-actions', [(_vm.user && _vm.user.status !== 'Activated') ? _c('div', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.resendActivationEmail(_vm.user.email)
      }
    }
  }, [_vm._v("Resend activation email")])], 1) : _vm._e(), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeUpdateDialog(false)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeUpdateDialog(true)
      }
    }
  }, [_vm._v("Update")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "confirmDialog"
  }, [_c('md-dialog-title', [_vm._v("Are you sure you would like to remove this user?")]), _vm._v(" "), _c('md-dialog-content', [_vm._v("\n      User will permanently be removed from the database\n    ")]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeConfirmDialog(false)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeConfirmDialog(true)
      }
    }
  }, [_vm._v("Delete")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-29dccffc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminTabs/AdminUsers.vue
// module id = 303
// module chunks = 2